
export default class UtilityLimitIncreaseProofOfIncomeType{

    constructor(jsonResponse){
        this.name = jsonResponse["name"];
        this.displayValue = jsonResponse["display-value"];
    }

}
